import { createResource, useResource } from '@/lib/i18n'
import { useWindowSize } from '@/lib/use-hooks/use-window-size'
import React from 'react'
import styled from 'styled-components'
import { Swiper, SwiperSlide } from 'swiper/react'
import { Animation, Reveal } from 'react-genie'

const resource = createResource({
  id: {
    title: 'Cara Membayar Pinjaman Kredit Pintar',
    repay1: `Cek info tagihan Anda pada menu 'Tagihan'`,
    repay2: `Tekan 'Bayar'`,
    repay3: `Pilih metode pembayaran 'Virtual Account'`,
    repay4: 'Pilih Bank yang Anda gunakan',
    repay5: 'Salin kode Virtual Akun, dan tempel di aplikasi Bank atau Internet Banking yang Anda gunakan',
    repay6: 'Masukkan nominal tagihan yang tertera pada aplikasi Kredit Pintar',
    repay7: `Tekan 'OK' untuk menyelesaikan transaksi Anda`,
    repay8: 'Pembayaran Berhasil!',
    repay9: 'Status pembayaran akan otomatis terupdate di aplikasi',
  },
  en: {
    title: 'How to Repay Kredit Pintar Repayment',
    repay1: `Check your bill in 'Bill' menu`,
    repay2: `Click 'Pay'`,
    repay3: `Choose 'Virtual Account' as the payment method`,
    repay4: 'Choose the bank name that you use',
    repay5: 'Copy the virtual account and paste in the Bank application or Internet Banking that you use',
    repay6: 'Input the bill nominal displayed in Kredit Pintar application',
    repay7: `Click 'OK' to finish your transaction`,
    repay8: 'Payment successfully done!',
    repay9: 'Your payment status will be updated automatically in the application',
  },
})

type IRepayMethod = {
  imagePath: string
  desc: string
}

const HowRepay = () => {
  const { t } = useResource(resource)
  const { width } = useWindowSize()
  const repayMethods: IRepayMethod[] = [
    {
      imagePath: '/images/product/how-repay-1.png',
      desc: 'repay1',
    },
    {
      imagePath: '/images/product/how-repay-2.png',
      desc: 'repay2',
    },
    {
      imagePath: '/images/product/how-repay-3.png',
      desc: 'repay3',
    },
    {
      imagePath: '/images/product/how-repay-4.png',
      desc: 'repay4',
    },
    {
      imagePath: '/images/product/how-repay-5.png',
      desc: 'repay5',
    },
    {
      imagePath: '/images/product/how-repay-6.png',
      desc: 'repay6',
    },
    {
      imagePath: '/images/product/how-repay-7.png',
      desc: 'repay7',
    },
    {
      imagePath: '/images/product/how-repay-8.png',
      desc: 'repay8',
    },
    {
      imagePath: '/images/product/how-repay-9.png',
      desc: 'repay9',
    },
  ]
  return (
    <HowRepayStyles>
      {width >= 1000 ? (
        <div className="how-repay-pc">
          <div className="how-repay-title">{t('title')}</div>
          <div className="how-repay-items">
            {repayMethods.map((item: IRepayMethod, index: number) => (
              <Reveal key={item.imagePath} delay={200 + index * 150} animation={Animation.FadeIn}>
                <HowRepayItemStyles {...item}>
                  <div className="how-repay-item">
                    <div className="how-repay-item-desc">
                      <div className="how-repay-item-inner">{t(item.desc as any)}</div>
                    </div>
                  </div>
                </HowRepayItemStyles>
              </Reveal>
            ))}
          </div>
        </div>
      ) : (
        <div className="how-repay-mobile">
          <div className="how-repay-title">{t('title')}</div>
          <Swiper className="how-repay-items" loop={true} pagination={{ clickable: true }}>
            {repayMethods.map((item: IRepayMethod) => (
              <SwiperSlide className="swiper-slide" key={item.imagePath}>
                <HowRepayItemStyles {...item}>
                  <div className="how-repay-item">
                    <div className="how-repay-item-desc">
                      <div className="how-repay-item-inner">{t(item.desc as any)}</div>
                    </div>
                  </div>
                </HowRepayItemStyles>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      )}
    </HowRepayStyles>
  )
}

export default HowRepay

const HowRepayItemStyles = styled.div<IRepayMethod>`
  @media only screen and (min-width: 1000px) {
    margin-left: 36px;
    .how-repay-item {
      width: 200px;
      height: 258px;
      background-image: url(${(props) => `${props.imagePath}`});
      background-size: 100% 100%;
      background-repeat: no-repeat;
      margin-bottom: 36px;
    }
  }
  @media only screen and (max-width: 1000px) {
    .how-repay-item {
      width: 200px;
      height: 258px;
      background-image: url(${(props) => `${props.imagePath}`});
      background-size: 100% 100%;
      background-repeat: no-repeat;
      margin: 0 auto 72px;
    }
  }
  .how-repay-item-desc {
    text-align: center;
    font-size: 12px;
    font-family: Roboto-Bold, Roboto;
    font-weight: bold;
    color: rgba(0, 0, 0, 0.87);
    height: 52px;
    width: 100%;
    position: relative;
    top: 73.5%;
    padding: 0 21px;
    display: table;
    .how-repay-item-inner {
      line-height: 13px;
      display: table-cell;
      vertical-align: middle;
    }
  }
`

const HowRepayStyles = styled.div`
  @media only screen and (min-width: 1000px) {
    .how-repay-pc {
      margin: 40px auto 0;
      max-width: 1440px;
      height: 900px;
      background-image: url('/images/product/how-rapay-bg.png');
      background-size: 100% 100%;
      background-repeat: no-repeat;
      .how-repay-title {
        font-size: 36px;
        font-family: Roboto-Medium, Roboto;
        font-weight: 500;
        color: rgba(0, 0, 0, 0.87);
        line-height: 48px;
        padding-top: 99px;
        text-align: center;
      }
      .how-repay-items {
        width: 1376px;
        padding: 40px 0px 0;
        display: flex;
        justify-content: center;
        flex-wrap: wrap;
        margin: 0 auto;
      }
    }
  }
  @media only screen and (max-width: 1000px) {
    margin-bottom: 64px;
    .how-repay-mobile {
      padding: 0 24px;
      text-align: center;
      height: 639px;
      background-image: url('/images/product/how-pay-mobile-bg.png');
      background-size: 100% 100%;
      background-repeat: no-repeat;
      .how-repay-title {
        padding-top: 50px;
        font-size: 28px;
        font-family: Roboto-Medium, Roboto;
        font-weight: 500;
        color: rgba(0, 0, 0, 0.87);
        line-height: 36px;
        padding-bottom: 48px;
      }
    }
  }
`
